import {Injectable, NgZone} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Store} from "@ngxs/store";
import {AuthenticationService} from "../../service/auth.service";
import {AccountState} from "../../states/account.state";
import {SwalUtil} from "../../util/swal-util";

@Injectable({
    providedIn: 'root'
})
export class BaseDocumentationGuard  {

  constructor(
    protected router: Router,protected store:Store,
    protected authenticationService: AuthenticationService,
    protected ngZone:NgZone, protected swalUtil:SwalUtil
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const accountStatus = this.store.selectSnapshot(AccountState.getAccountStatus);
    if (accountStatus) {
      let level = parseInt(accountStatus.level.id);
      if(level < 2) {
        this.showMessage();
        return false;
      } else {
        return true;
      }
    } else {
      this.router.navigate(['/home'])
      return false;
    }
    return false;
  }

  protected showMessage(): void {
    SwalUtil.fireGenericMessage("Atención", "No tienes los privilegios suficientes");
  }

  // SwalUtil.fireGenericMessage("Atención", "Debes completar la información adicional para poder vender cheques.")
}
